module.exports = __webpack_public_path__ + "static/img/4.7f32813.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/4.png
// module id = wFvE
// module chunks = 0